import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userInfo: localStorage.getItem('userInfo')
    ? JSON.parse(localStorage.getItem('userInfo'))
    : null,
};

const authSlice = createSlice({
  name: 'auth ',
  initialState,
  reducers: {
    setCredentials: (state, { payload }) => {
      state.userInfo = payload;
      localStorage.setItem('userInfo', JSON.stringify(payload));
    },
    logout: (state, { payload }) => {
      state.userInfo = null;
      localStorage.removeItem('userInfo');
    },
  },
});

export default authSlice.reducer;

export const { setCredentials, logout } = authSlice.actions;
